import { DiaryFiltersFormValues } from "shared/types";
import { DiaryFiltersItem, DiaryFiltersItemTitle, DiaryFiltersRangeItemFooter, DiaryFiltersTextareaLabel } from "./styles"
import { FC, useMemo, useState } from "react";
import TagGroup from '@atomaro/ui-kit/components/Tag/TagGroup/TagGroup';
import { toRem } from "shared/helpers";
import { Control, Controller } from "react-hook-form";
import { ITagGroupItem } from "@atomaro/ui-kit/components/Tag/TagGroup/types";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';

type DiaryCommentFilterProps = {
  formValues: Partial<DiaryFiltersFormValues>;
  control: Control<DiaryFiltersFormValues, any, DiaryFiltersFormValues>;
  showFooter?: boolean;
  hideHeader?: boolean;
  onCommentChange: (value: string[]) => void;
  onSubmitClick?: () => void;
  onCancelClick?: () => void;
}

export const DiaryCommentFilter: FC<DiaryCommentFilterProps> = ({
  formValues,
  control,
  showFooter,
  hideHeader,
  onCommentChange,
  onSubmitClick,
  onCancelClick
}) => {

  const keyWords = useMemo(() => {
    return formValues?.commentKeyWords?.map(el => ({key: el, value: el})) || []
  }, [formValues]);

  const [ value, setValue ] = useState<string>('');

  const onBlur = (e: any) => {
    const val = e.target.value;
    if (!val.trim()) return;

    const arr = structuredClone?.(keyWords) || JSON.parse(JSON.stringify(keyWords));
    const finded = arr.find(el => el.key === val);
    if (finded) return;
    arr.push({key: val, value: val})
    onCommentChange(arr.map(el => el.key))
    setValue('');
  }

  const onRemove = (removedTag: ITagGroupItem) => {
    const arr = (structuredClone?.(keyWords) || JSON.parse(JSON.stringify(keyWords))).map(el=>el.key);
    const findIndex = arr.findIndex(el=>el===removedTag.key)
    arr.splice(findIndex, 1);
    onCommentChange(arr)
  }

  return (
    <DiaryFiltersItem>
      {!hideHeader && 
      <DiaryFiltersItemTitle>
        <span>Комментарий</span>
      </DiaryFiltersItemTitle>
      }
      <Controller 
        control={control}
        name="commentKeyWords"
        render={({field}) => (
          <>
            <DiaryFiltersTextareaLabel>Ключевые слова</DiaryFiltersTextareaLabel>
            <textarea 
              name={field.name}
              value={value}
              onChange={(event) => setValue(event.target.value)}
              onBlur={onBlur}
            ></textarea>
          </>
        )}
      />
      <TagGroup 
        closable
        items={keyWords}
        onRemove={onRemove}
        style={{
          paddingTop: toRem(16)
        }}
      />
      {showFooter && 
      <DiaryFiltersRangeItemFooter>
          <Button 
            label="Отменить"
            variant="ghost"
            colorScheme="neutral"
            onClick={onCancelClick}
          />
          <Button 
            label="Применить"
            onClick={onSubmitClick}
          />
      </DiaryFiltersRangeItemFooter>
      }
    </DiaryFiltersItem>
  )
}